export default {
  loading: false,
  loadingExporting: false,
  loadingListStatus: false,
  loadingListSubStatus: false,
  loadingReprocess: false,
  loadingPayload: false,
  listStatus: [],
  listSubStatus: [],
  listTypeEvents: [
    {
      value: null,
      label: 'Todos',
    },
    {
      value: 'SHIPPER',
      label: 'Embarcador',
    },
    {
      value: 'LOGISTIC_PROVIDER',
      label: 'Transportadora',
    },
    {
      value: 'INTELIPOST',
      label: 'Intelipost',
    },
  ],
  logs: {
    events: [],
    total: 0,
  },
  event: null,
  lote: null,
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-analytic/features/logs/pages/tracking/store/states.js